<template>
  <div v-if="documents.length || files.length || $store.getters.isAgent === true" class="profile-tile">
    <h4 class="" style="font-weight: 500; margin-bottom: 0;">Documents</h4>
    <hr>

    <div class="row">
      <div v-for="document in documents" :key="document.id" class="col-lg-4">
        <div class="center py-4 px-3 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <div v-if="!document.template">
            <h5 class="mb-3">{{ document.title }}<span v-if="document.title == 'Medical Release'"> - {{ document.field1 }}</span></h5>
            <!-- <button v-if="document.title == 'Transportation Consent' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showTransportationConsentModal(document)">Sign</button>
            <button v-if="document.title == 'Transportation Consent' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showTransportationConsentModal(document)">View</button>
            <button v-if="document.title == 'Use of Client Vehicle' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showUseofClientVehicleModal(document)">Sign</button>
            <button v-if="document.title == 'Use of Client Vehicle' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showUseofClientVehicleModal(document)">View</button>
            <button v-if="document.title == 'Transport with Employee Vehicle' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showTransportChildrenEmployeeVehicleModal(document)">Sign</button>
            <button v-if="document.title == 'Transport with Employee Vehicle' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showTransportChildrenEmployeeVehicleModal(document)">View</button>
            <button v-if="document.title == 'Medical Release' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showMedicalReleaseModal(document)">Sign</button>
            <button v-if="document.title == 'Medical Release' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showMedicalReleaseModal(document)">View</button>

            <button v-if="document.title == 'Client Agency Agreement' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showFamilyAgencyContractModal(document)">Sign</button>
            <button v-if="document.title == 'Client Agency Agreement' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showFamilyAgencyContractModal(document)">View</button> -->
          </div>

          <div v-if="document.template">
            <!-- {{ document }} -->
            <h5 class="mb-3">{{ document.title }}<span v-if="document.status == 'Signed'"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>
            <button v-if="document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showDocumentModal(document)">Sign</button>
            <!-- <button v-if="document.status == 'Unsigned' && $store.getters.isAgent === true" class="mylisting-button dark-button mt-2" @click="showEditDocumentModal(document)">Edit</button> -->
            <button v-if="document.status == 'Signed'" class="mylisting-button dark-button" @click="showDocumentModal(document)">View</button>
            <!-- <button v-if="$store.getters.isAgent === true" class="mylisting-button danger-button" @click="deleteDocument(document)">Delete</button> -->
          </div>

          <p v-if="$store.getters.isAgent === true" class="delete-text mt-2" @click="showDeleteDocumentModal(document)">Delete</p>
        </div>
      </div>

      <div v-for="file in files" :key="file.id" class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">{{ file.name }}</h5>
          <a style="" :href="file.file_link" target="_blank"><button class="mylisting-button dark-button">View</button></a>
          <p v-if="$store.getters.isAgent === true" class="delete-text mt-2" @click="showDeleteFileModal(file)">Delete</p>
        </div>
      </div>
    </div>

    <div v-if="$store.getters.isAgent === true">
      <button class="mylisting-button dark-button mt-4" @click="showUploadFileModal()">Upload File</button>
    </div>

    <!-- <modal name="transportation-consent-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <transportation-consent :user="user" :document="document" @documentSigned="documentSigned()"></transportation-consent>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('transportation-consent-modal')">Close</button>
      </div>
    </modal>

    <modal name="useof-client-vehicle-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <useof-client-vehicle :user="user" :document="document" @documentSigned="documentSigned()"></useof-client-vehicle>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('useof-client-vehicle-modal')">Close</button>
      </div>
    </modal>

    <modal name="transport-children-employee-vehicle-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <transport-children-employee-vehicle :user="user" :document="document" @documentSigned="documentSigned()"></transport-children-employee-vehicle>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('transport-children-employee-vehicle-modal')">Close</button>
      </div>
    </modal>

    <modal name="medical-release-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <medical-release :user="user" :document="document" @documentSigned="documentSigned()"></medical-release>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('medical-release-modal')">Close</button>
      </div>
    </modal>

    <modal name="family-agency-contract-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <family-agency-contract :user="user" :document="document" @documentSigned="documentSigned()"></family-agency-contract>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('family-agency-contract-modal')">Close</button>
      </div>
    </modal> -->

    <modal name="upload-file-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="">
          <label style="">File Name</label>
          <input type="text" class="form-control mb-2" v-model="fileName">
          <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="file" ref="file" v-on:change="handleFileUpload()"/>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('upload-file-modal')" style="">Close</button>
        <button v-if="fileName && file" class="mylisting-button dark-button" @click="uploadFile()">Upload File</button>
      </div>
    </modal>

    <modal name="document-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <document :user="user" :document="document" @documentSigned="documentSigned()" @documentSaved="documentSaved()"></document>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('document-modal')">Close</button>
        <!-- <button class="mylisting-button secondary-button float-right" v-if="document.signing_name" @click="downloadPDF()">Download PDF</button> -->
      </div>
    </modal>

    <modal name="document-signed-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Your document has been signed.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('document-signed-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="delete-document-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="">
          <h3>Are you sure you want to delete the document {{ document.title }}?</h3>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-document-modal')" style="">Close</button>
        <button class="mylisting-button danger-button" style="float: right;" @click="deleteDocument(document)">Delete Document</button>
      </div>
    </modal>

    <modal name="delete-file-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="">
          <h3>Are you sure you want to delete the file {{ file.name }}?</h3>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-file-modal')" style="">Close</button>
        <button class="mylisting-button danger-button" style="float: right;" @click="deleteFile(selectedFile)">Delete File</button>
      </div>
    </modal>

    <modal name="delete-document-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="">
          <h3>Are you sure you want to delete the document {{ document.title }}?</h3>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-document-modal')" style="">Close</button>
        <button class="mylisting-button danger-button" style="float: right;" @click="deleteDocument(document)">Delete Document</button>
      </div>
    </modal>

  </div>
</template>

<script>
import axios from 'axios'

import TransportationConsent from './TransportationConsent'
import UseofClientVehicle from './UseofClientVehicle'
import TransportChildrenEmployeeVehicle from './TransportChildrenEmployeeVehicle'
import MedicalRelease from './MedicalRelease'

import FamilyAgencyContract from './FamilyAgencyContract'

import Document from '../../candidates/profile/Document'

export default {
  props: ['user'],
  components: {
    TransportationConsent,
    UseofClientVehicle,
    TransportChildrenEmployeeVehicle,
    MedicalRelease,

    FamilyAgencyContract,

    Document,
  },
  data() {
    return {
      documents: [],
      document: {},

      files: [],
      file: '',
      fileName: '',
      selectedFile: {},
    }
  },
  created() {
    this.getDocuments()
    this.getFiles()
  },
  methods: {
    getDocuments() {
      axios.get(`/api/documents/?signing_user=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.documents = res.data
          this.documents = this.documents.sort((a, b) => (a.id > b.id) ? 1 : -1)
        })
    },
    showTransportationConsentModal(document) {
      this.document = document
      this.$modal.show('transportation-consent-modal')
    },
    showUseofClientVehicleModal(document) {
      this.document = document
      this.$modal.show('useof-client-vehicle-modal')
    },
    showTransportChildrenEmployeeVehicleModal(document) {
      this.document = document
      this.$modal.show('transport-children-employee-vehicle-modal')
    },
    showMedicalReleaseModal(document) {
      this.document = document
      this.$modal.show('medical-release-modal')
    },

    showFamilyAgencyContractModal(document) {
      this.document = document
      this.$modal.show('family-agency-contract-modal')
    },

    showDocumentModal(document) {
      this.document = document
      this.$modal.show('document-modal')
    },
    documentSigned() {
      this.getDocuments()
      // this.$modal.hide('transportation-consent-modal')
      // this.$modal.hide('useof-client-vehicle-modal')
      // this.$modal.hide('transport-children-employee-vehicle-modal')
      // this.$modal.hide('medical-release-modal')
      // this.$modal.hide('family-agency-contract-modal')

      this.$modal.hide('document-modal')
      this.$modal.show('document-signed-modal')
    },
    documentSaved() {
      this.getDocuments()
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    getFiles() {
      axios.get(`/api/files/?user=${this.user.id}`)
        .then(res => {
          this.files = res.data
        })
        .catch(error => console.log(error))
    },
    showUploadFileModal() {
      this.$modal.show('upload-file-modal')
    },
    uploadFile() {
      axios.post(`/api/files/`, {
        user: this.user.id,
        name: this.fileName,
      })
        .then(res => {
          let formData = new FormData();
          if (this.file) {
            formData.append("file_link", this.file);
          }
          axios.patch(`/api/files/${res.data.id}/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          )
            .then(res => {
              this.getFiles()
              this.$modal.hide('upload-file-modal')
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    },
    showDeleteFileModal(file) {
      this.selectedFile = file
      this.$modal.show('delete-file-modal')
    },
    deleteFile(file) {
      axios.delete(`/api/files/${file.id}/`)
        .then(res => {
          this.getFiles()
          this.$modal.hide('delete-file-modal')
        })
        .catch(error => console.log(error))
    },
    showDeleteDocumentModal(document) {
      this.document = document
      this.$modal.show('delete-document-modal')
    },
    deleteDocument(document) {
      axios.delete(`/api/documents/${document.id}/`)
        .then(res => {
          this.getDocuments()
          this.$modal.hide('delete-document-modal')
        })
        .catch(error => console.log(error))
    },
    unsignDocument(document) {
      axios.patch(`/api/documents/${document.id}/`, {
        status: 'Unsigned',
        signing_name: '',
      })
        .then(res => {
          this.getDocuments()
        })
        .catch(error => console.log(error))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employers/documents/Documents.vue